export default __webpack_public_path__ + "static/media/features5.3441fe0a.jpg";